export default __webpack_public_path__ + "static/media/disponivel-na-app-store.bed42bd8.png";